import React from "react";

export default function ArrowLeft() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.409 20.8182L10.5908 14L17.409 7.18182"
        stroke="#123333"
        strokeWidth="2.72727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
